<nav class="nav-container">
  <div class="header">
    <mat-icon
      aria-label="left pointing chevron"
      fontIcon="arrow-left"
      (click)="goBack()"
      >arrow_back_ios</mat-icon
    >
    <p class="textEvent" (click)="goBack()">Back to Unit</p>
  </div>
  <div>
    <img [src]="unitImage" width="150" height="100" alt="unit" />
    <select
      class="page-selector"
      [(ngModel)]="selection"
      (change)="onSelection()"
    >
      <option [ngValue]="null">Select a Page</option>
      <option
        *ngFor="let page of pages; let i = index"
        [value]="page.dayNumber"
      >
        {{
          page.isQuiz
            ? 'Assessment'
            : page.dayEndPage
            ? (page.dayStartPage | truncateText: 5) +
              '-' +
              (page.dayEndPage | truncateText: 5)
            : (page.dayStartPage | truncateText: 5)
        }}
      </option>
    </select>
  </div>
</nav>
